// config is used through most of the game files and shoulc contain alll games constants
import config from './config';
// contains helper function related to the game or Phaser itself
import { resizeGame } from './utils';
import SdkEmulator from './utils/SdkEmulator';
// A simple class used for logging out values outside of the console and game canvas
import Debug from './utils/Debug';
import ChildCounter from './utils/ChildCounter';

import DataManager from './utils/DataManager';
import APIManager from './utils/APIManager';
import SoundManager from './utils/SoundManager';

// The scenes that make up our game
import Boot from './scene/Boot';
import Preload from './scene/Preload';
import Intro from './scene/Intro';
// import Transitions from './scene/Transitions';
import SettingsPanel from './scene/SettingsPanel';
import Pause from './scene/Pause';
import Play from './scene/Play';
import EndScore from './scene/EndScore';

import OrientationChecker from './mp/OrientationChecker';

// old
// var domReady = false;
// var sdkReady = false;
// var gameStarted = false;
// var SDK_REF = null;
// let sdkPauseActive = false;

let windowDomReady = false;
let gameStarted = false;

let sdkReady = true;
let SDK_REF = new SdkEmulator();

window.addEventListener('load', () => {
  // console.log('window load event');
  windowDomReady = true;
  startOrientationChecker();
});

document.addEventListener('DOMContentLoaded', () => {
  // console.log('DOMContentLoaded event');
  windowDomReady = true;
  startOrientationChecker();
});

function startOrientationChecker() {
  if (window.orientationChecker) { return; }
  window.orientationChecker = new OrientationChecker("", startGame);
}

function startGame () {
  if (!windowDomReady || !sdkReady || gameStarted) {
    return;
  }

  gameStarted = true;
  SDK_REF.debug('startGame');
  // console.log('startGame');

  let game = new Phaser.Game({
    type: Phaser.AUTO,
    width: config.WIDTH,
    height: config.HEIGHT,
    backgroundColor: 0x03030d,
    resolution: config.DEVICE_PIXEL_RATIO
  });

  game.sdk = SDK_REF;
  game.apiManager = new APIManager(SDK_REF);
  game.dataManager = new DataManager();
  // game.sdkPauseActive = sdkPauseActive;

  // Add our scenes to the Phaser Game
  game.scene.add('Boot', Boot);
  game.scene.add('Preload', Preload);
  // game.scene.add('Transitions', Transitions);
  game.scene.add('SettingsPanel', SettingsPanel);
  game.scene.add('Pause', Pause);
  game.scene.add('Intro', Intro);
  game.scene.add('Play', Play);
  game.scene.add('EndScore', EndScore);
  game.scene.add('SoundManager', SoundManager);
  game.scene.start('Boot');

  let resizeGameBound = resizeGame.bind(game);
  window.focus();
  resizeGameBound();
  window.addEventListener('resize', resizeGameBound);

  if (__DEV__) {
    // start stats, comment out for production
    // let stats = new Stats();
    // document.body.appendChild(stats.dom);
    // game.stats = stats;
    // end stats
    // game.debug = new Debug({
    //   bottom: '0px',
    //   left: 0
    // });
    // switch (game.renderer.type) {
    //   case Phaser.WEBGL:
    //     game.debug.setText('Renderer type: WEBGL');
    //     break;
    //   case Phaser.CANVAS:
    //     game.debug.setText('Renderer type: CANVAS');
    //     break;
    // }
    new ChildCounter(game);
  }

  const onWindowBlurBound = onWindowBlur.bind(game);
  const onWindowFocusBound = onWindowFocus.bind(game);
  const onVisibilityChangeBound = onVisibilityChange.bind(game);

  window.addEventListener("blur", onWindowBlurBound);
  window.addEventListener("focus", onWindowFocusBound);
  document.addEventListener("visibilitychange", onVisibilityChangeBound);
}

function onVisibilityChange () {
  if (document.hidden || document.msHidden || document.webkitHidden) {
    onWindowBlur.call(this);
  }
  else {
    onWindowFocus.call(this);
  }
}

function onWindowBlur () {
    this.sound.mute = true;
}

function onWindowFocus () {
    this.sound.mute = false;
}

// document.addEventListener('DOMContentLoaded', function (event) {
//   console.log('DOM fully loaded and parsed');
//   if (SDK_REF) {
//     SDK_REF.debug('DOM fully loaded and parsed');
//   }
//   domReady = true;
//   checkGameReady();
// });

// window.addEventListener('load', function () {
//   console.log('Window loaded');
//   if (SDK_REF) {
//     SDK_REF.debug('Window loaded');
//   }
//   domReady = true;
//   checkGameReady();
// });

// window['PlayPromise'].then(function (sdk) {
//   sdk.debug('Play Promise Success');
//   console.log('Play Promise Success');
//   sdk.setPauseFunction(() => {
//     sdkPauseActive = true;
//   });
//   sdk.setPlayFunction(() => {
//     sdkPauseActive = false;
//   });
//   sdkReady = true;
//   SDK_REF = sdk;
//   checkGameReady();
// });

// function checkGameReady () {
//   console.log('checkGameReady domReady: ' + domReady + ' sdkReady: ' + sdkReady + ' gameStarted: ' + gameStarted);
//   if (SDK_REF) {
//     SDK_REF.debug('checkGameReady domReady: ' + domReady + ' sdkReady: ' + sdkReady + ' gameStarted: ' + gameStarted);
//   }
//   if (domReady && sdkReady) {
//     if (gameStarted === false) {
//       gameStarted = true;
//       startGame();
//     }
//   }
// }
